import initializeInvitations from '@/accounts/initializers/invitations'
import initializeUsers from '@/accounts/initializers/users'

export default [
  initializeInvitations,
  initializeUsers
]
